module.exports = {
  QueryBalance: 'Запрос клиентов с предоплатой',
  QueryDetail: 'Запрос деталей предоплаты',
  BalanceDetail: 'Детали изменения баланса',
  FinanceBalance: 'Баланс финансовой системы',
  SendBalance: 'Отправить список',
  QuerySendBalanceState: 'Проверка статуса отправки списка',
  InitializeBalance: 'Инициализация баланса',
  QuickSearchBalance: 'Быстрый поиск: код клиента',
  CustomerName: 'Наименование клиента',
  CustomerCode: 'Код клиента',
  SalesName: 'Продажи',
  ParentBranchName: 'Название вышестоящей организации',
  ParentBranchCode: 'Код вышестоящей организации',
  BranchName: 'Название подразделения',
  BranchCode: 'Код подразделения',
  BranchId: 'Принимающая организация',
  Balance: 'Баланс',
  DateCreated: 'Дата создания',
  State: 'Статус синхронизации списка',
  SubmittingAmount: 'Сумма в процессе отправки',
  ShowChildData: 'Показать дочерние компании',
  ChangeAmount: 'Изменение суммы',
  ChangeType: 'Тип изменения баланса',
  LatestBalance: 'Последний баланс',
  ChangeDate: 'Дата операции',
  Currency: 'Валюта',
  JobNo: 'Номер операции',
  FinanceUpdateDate: 'Дата обновления в финансовой системе',
  SyncDate: 'Дата синхронизации',
  CheckBalanceTitle: 'Недостаточно средств на предоплате',
  CheckBalanceDetail: '{0}, [{1}]{2}: текущий баланс {3} RMB. Отправляемые операции заблокировали {4} RMB. Текущая отправка {5} RMB',
  CheckBalanceDetail2: '[{0}]{1}: текущий баланс {2} RMB. Отправляемые операции заблокировали {3} RMB. Текущая отправка {4} RMB',
  CustSettlement: 'Способ расчёта клиента',
  InstCode: 'Код отделения',
  InstName: 'Название отделения',
  SrcSystem: 'Операционная система',
  AdvBalance: 'Текущий баланс предоплаты',
  OrderType: 'Тип операции',
  BlacklistRemark: 'Примечание чёрного списка',
  AddedToBlacklist: '{0} добавлен в чёрный список',
  BalanceInitialized: 'После инициализации баланса клиент "предоплата" не может быть переведён обратно в "кредит"',
  CustomerCodeDuplicate: 'Дублирование кода клиента',
  NoMatchStateBySelected: 'Нет записей с состоянием [{0}]',
  SendCustomerInfo: 'Отправить список',
  SendCustomerRemind: '*Внимание: убедитесь, что код и название подразделения клиента совпадают с данными финансовой системы. В противном случае синхронизация баланса и пополнения будет невозможна.'
}
